import { setAttribute } from './index';

type IncomingParam = Record<string, string>;

const safeParse = <T>(key: string): T | null => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

const safeDecode = (value?: string): string | undefined => {
  if (!value) return undefined;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const readSmartScriptChannelSignal = (): string | null => {
  const params: IncomingParam = safeParse<IncomingParam[]>('ss_incoming_params')?.[0] ?? {};
  const referrer: string | null = safeParse<string>('ss_webReferrer');

  const utm_source = safeDecode(params['utm_source']);
  const utm_medium = safeDecode(params['utm_medium']);

  if (!utm_source && !utm_medium && !referrer) return null;

  return JSON.stringify({ utm_source, utm_medium, referrer });
};

export const collectSessionAttributes = (): void => {
  if (typeof navigator !== 'undefined') {
    setAttribute('userAgent', navigator.userAgent);
  }

  const channel = readSmartScriptChannelSignal();
  if (channel) setAttribute('channel', channel);
};
